import React, { FC, useCallback } from 'react';
import moment from 'moment';
import Intervention from 'src/interfaces/api/Intervention';
import { MdTimer as TimerIcon } from '@react-icons/all-files/md/MdTimer';
import { createUseStyles } from 'src/theming';
import { getFormatedDuration } from 'src/utils/TimeUtils';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  icon: {
    marginLeft: 5,
  },
});

interface Props {
  interventions: Array<Intervention>;
}

const InterventionsTime: FC<Props> = ({ interventions }) => {
  const classes = useStyles();

  const getTotalInterventionsDurations = useCallback(() => {
    const duration = Object.values(interventions).reduce((total, intervention) => {
      const duration = moment(intervention.endDate).diff(intervention.startDate, 'minutes');
      return total + duration;
    }, 0);

    return getFormatedDuration(duration);
  }, [interventions]);

  return (
    <div className={classes.root}>
      {getTotalInterventionsDurations()} <TimerIcon className={classes.icon} />
    </div>
  );
};

export default InterventionsTime;
